import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { IncomingInvoiceListItem } from "@msuite/utils/types";
import { useNavigate } from "react-router";

export function RowActions({ cell }: CellContext<IncomingInvoiceListItem, "actions">) {
	/** Hooks */
	const { t } = useTranslation();
	const navigate = useNavigate();
	const incomingInvoiceId = cell.row.original.id;

	/** Render */
	return (
		<RowActionsWrapper to={`/controlling/incoming-invoices/${incomingInvoiceId}`}>
			<Menu
				items={() => [
					{
						label: t("general.open"),
						icon: icon("Info"),
						onClick: () => navigate(`/controlling/incoming-invoices/${incomingInvoiceId}`),
						cyId: "row-actions-open-button",
					},
				]}
			>
				<Button
					size="xxs"
					icon={<Icon name="EllipsisVertical" />}
					variant="ghost"
					data-cy="row-actions-button"
				/>
			</Menu>
		</RowActionsWrapper>
	);
}
